export const getContents = state => state.contentsNext
